export {default as DownOutline} from '@ant-design/icons/lib/outline/DownOutline'
export {default as UpOutline} from '@ant-design/icons/lib/outline/UpOutline'
export {default as LoadingOutline} from '@ant-design/icons/lib/outline/LoadingOutline'
export {default as CloseOutline} from '@ant-design/icons/lib/outline/CloseOutline'